import { Component, computed, effect, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SubscriptionService } from "../../../services/subscriptionservice";
import { openDialogIncident } from "../../dialogs/dialog-incident/dialog-incident";
import { getDetailRouterLink } from "../../../helpers/getDetailRouterLink";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderComponent } from "../../common/loader/loader";
import { RouterModule } from "@angular/router";
import { AngularSvgIconModule } from "angular-svg-icon";
import { AliasEditorComponent } from "../../common/alias-editor/alias-editor.component";
import { KpiRowComponent } from "../kpi-row/kpi-row";
import { ServiceElementTagsComponent } from "../service-element-tags/service-element-tags";
import { ServiceSubtitleComponent } from "../service-subtitle/service-subtitle";
import { WirelessSubscriptionDetailsType } from "../../../gql/generated-ingestor";

@Component({
  selector: "wireless-element",
  templateUrl: "wireless-element.html",
  imports: [
    AliasEditorComponent,
    AngularSvgIconModule,
    KpiRowComponent,
    LoaderComponent,
    RouterModule,
    ServiceElementTagsComponent,
    ServiceSubtitleComponent,
    TranslateModule,
  ],
})
export class WirelessElement {
  private dialog = inject(MatDialog);
  private subscriptionService = inject(SubscriptionService);

  protected subscription = input.required<WirelessSubscriptionDetailsType>();
  protected productType = computed(() => this.subscription().product.type);

  protected sensorPresent = computed(() => this.subscription().sensorPresent);
  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected customerDescription = computed(() => this.subscription().customerDescription);
  protected tags = computed(() => this.subscription().tags);
  protected vendor = computed(() => this.subscription().supplier);

  private location = computed(() => this.subscription().location);
  protected activeAps = computed(() => this.location().activeAccessPoints);
  protected inactiveAps = computed(() => this.location().inactiveAccessPoints);
  protected routerLink = computed(() => getDetailRouterLink(this.subscription(), this.productType()));

  protected kpiList: {
    kpiAverages: { [key: string]: number }[];
  };

  constructor() {
    effect(() =>
      this.subscriptionService.getWirelessListKpiForSubscription(this.subscriptionId()).then((kpiList) => {
        this.kpiList = kpiList;
      }),
    );
  }

  openIncidentDialog(event) {
    event.stopPropagation();
    event.preventDefault();
    openDialogIncident(this.dialog, this.subscription());
    return false;
  }
}
